import Styled from './styled'

export default function TermAndCondition({ data }) {
  const content = data?.termCondition?.description || ''

  return (
    <Styled>
      <div className="container">
        <div className="term-content" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </Styled>
  )
}
